<template>
  <main class="overflow-hidden">
    <!-- Navigation -->
    <BlockNavigation
      v-if="route.name !== 'orders-id'"
      :user="user" />

    <!-- Page Slot -->
    <slot />
    <!-- Login Modal -->
    <ModalLogin v-if="showLoginModal" />
    <Intercom />
    <!-- Newsletter Button -->
    <NewsletterButton />
  </main>
</template>

<script setup lang="ts">
const user = useSupabaseUser()
const route = useRoute()
const showLoginModal = useState('showLoginModal', () => false)
</script>
